<p>devices-search-cards works!</p>
